const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900, // OLD 960
    lg: 1104, // OLD 1280
    xl: 1104 // OLD 1920
  }
};

export default breakpoints;
